import React from 'react';
import '../styles/chat.css';

interface LinkPopupProps {
    isVisible: boolean;
    onClose: () => void;
    url: string;
}

const LinkPopup: React.FC<LinkPopupProps> = ({ isVisible, onClose, url }) => {
    if (!isVisible) return null;

    return (
        <div className="link-popup-overlay">
            <div className="link-popup-container">
                <div className="link-popup-header">
                    {/* Bazi siteler (ozellikle odeme sayfalari) guvenlik nedeniyle
                        iframe icinde acilmayi engelliyor (X-Frame-Options/CSP).
                        Bu durumda kullanicinin sikismamasi icin yeni sekmede
                        acabilecegi bir kacis yolu her zaman gosteriliyor. */}
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link-popup-newtab"
                        onClick={onClose}
                    >
                        Yeni sekmede aç
                    </a>
                    <button className="link-popup-close" onClick={onClose}>
                        <span>×</span>
                    </button>
                </div>
                <div className="link-popup-content">
                    <iframe
                        src={url}
                        title="Link İçeriği"
                        className="link-popup-iframe"
                    />
                </div>
            </div>
        </div>
    );
};

export default LinkPopup; 